import { z } from 'zod'
import type { Feature } from '#/domain/customerAccess/Feature'

export const FeatureDtoSchema = z
  .object({
    Id: z.string(),
    Name: z.string(),
    DisplayName: z.string(),
    Description: z.string().nullish(),
    ApplicationId: z.string(),
    ApplicationName: z.string(),
  })
  .transform((raw): Feature => ({
    Id: raw.Id,
    Name: raw.Name,
    DisplayName: raw.DisplayName,
    Description: raw.Description ?? null,
    ApplicationId: raw.ApplicationId,
    ApplicationName: raw.ApplicationName,
  }))

export type FeatureResponseDto = z.input<typeof FeatureDtoSchema>

export function toDomain(raw: FeatureResponseDto): Feature {
  return FeatureDtoSchema.parse(raw)
}

export function toDomainList(raw: FeatureResponseDto[]): Feature[] {
  return raw.map(toDomain)
}
